import {Injectable, Injector} from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';

import {finalize, tap} from 'rxjs/operators';
import {LogService} from '../logging/log.service';

@Injectable()
export class LoggingInterceptor implements HttpInterceptor {
  private log: LogService;
  constructor(private injector: Injector) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    if (!this.log) {
      this.log = this.injector.get(LogService);
    }
    const started = Date.now();
    let ok: string;

    // extend server response observable with http-utilities
    return next.handle(req)
      .pipe(
        tap({
            next: event => {
              ok = event instanceof HttpResponse ? 'succeeded' : '';
            },
            error: error => {
              ok = 'failed';
            }
          }
        ),
        // Log when response observable either completes or errors
        finalize(() => {
          const elapsed = Date.now() - started;
          const msg = `${req.method} "${req.urlWithParams}"
             ${ok} in ${elapsed} ms.`;
          if (ok !== 'failed') {
            this.log.info(msg);
          }
        })
      );
  }
}
